var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2 2.4V0H6.4V2.4H5.6V1.6H4.8V2.4H4H3.2V3.2V4H2.4V4.8L2.4 11.2H0V12H12V11.2H9.6V4.8V4L8.8 4V3.2V2.4L8 2.4H7.2ZM6.4 3.2H5.6H4.8H4V4H8V3.2L7.2 3.2H6.4ZM3.2 4.8L8.8 4.8V11.2H3.2L3.2 4.8ZM8 6.4L4 6.4V5.6L8 5.6V6.4ZM4 8L8 8V7.2L4 7.2V8ZM8 9.6L4 9.6V8.8H8V9.6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1721 9.82366C16.0619 9.71088 16 9.55793 16 9.39845C16 9.23897 16.0619 9.08602 16.1721 8.97323L19.0813 5.99612L16.1721 3.01902C16.065 2.90558 16.0058 2.75366 16.0071 2.59597C16.0085 2.43827 16.0703 2.28742 16.1792 2.17591C16.2882 2.0644 16.4356 2.00115 16.5897 1.99978C16.7438 1.99841 16.8923 2.05903 17.0031 2.16859L20.3279 5.57091C20.4381 5.6837 20.5 5.83665 20.5 5.99612C20.5 6.1556 20.4381 6.30855 20.3279 6.42134L17.0031 9.82366C16.8929 9.93642 16.7434 9.99976 16.5876 9.99976C16.4318 9.99976 16.2823 9.93642 16.1721 9.82366Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar);
export default __webpack_public_path__ + "static/media/sidebar.c55ea882ff0b8d32bce02f5a084e52b8.svg";
export { ForwardRef as ReactComponent };